import React from 'react';
import './leadership.css';
import president from '../assets/leaders-images/president.jpg';
import secretary from '../assets/leaders-images/secretary.jpg';
import vicepresident from '../assets/leaders-images/vicepresident.jpg';
import jointsecretary from '../assets/leaders-images/joint-secretary.jpg';
import treasurer from '../assets/leaders-images/treasurer.jpg';
import sevanavibhagamcon from '../assets/leaders-images/sevanavibhagamcon.jpg';
import executive1 from '../assets/leaders-images/executive1.jpg';
import executive2 from '../assets/leaders-images/executive2.jpg';
import executive3 from '../assets/leaders-images/executive3.jpg';
import executive4 from '../assets/leaders-images/executive4.jpg';
// import executive5 from '../assets/leaders-images/executive5.jpg';

const leaders = {
  topLeaders: [
    { title: 'President', name: 'George M George', image: president },
    { title: 'Secretary', name: ' Nazifa Navas ', image: secretary },
  ],
  executives: [
    { title: 'Vice President', name: 'Nehala Fathima ', image: vicepresident },
    { title: 'Joint Secretary', name: 'Manna Liya Thomas', image: jointsecretary },
    { title: 'Treasurer', name: 'Nandhitha K T ', image: treasurer },
    { title: 'Sevana Vibhagam Covenor', name: 'Niya Mariya Joby', image: sevanavibhagamcon },
  ],
  convenors: [
    { title: 'Executive Member', name: 'Ann Mary Britto ', image: executive1 },
    { title: 'Executive Member', name: 'Ananya Krishna P', image: executive2 },
    { title: 'Executive Member', name: 'Arlin Anna Shibu  ', image: executive3 },
    { title: 'Executive Member', name: 'Diya B A  ', image: executive4 },
  ],
};

const Leadership = () => {
  return (
    <div className="leadership-page">
      <h1>LEADERSHIP 2025-2026</h1>

      {/* President and Secretary Row */}
      <div className="leader-row">
        {leaders.topLeaders.map((leader, index) => (
          <div key={index} className="leader-card">
            <img src={leader.image} alt={leader.title} />
            <h3>{leader.title}</h3>
            <p>{leader.name}</p>
          </div>
        ))}
      </div>

      {/* Executives Row (4 members) */}
      <div className="leader-row">
        {leaders.executives.map((executive, index) => (
          <div key={index} className="leader-card">
            <img src={executive.image} alt={executive.title} />
            <h3>{executive.title}</h3>
            <p>{executive.name}</p>
          </div>
        ))}
      </div>

      {/* Convenors Row (5 members) */}
      <div className="leader-row">
        {leaders.convenors.map((convenor, index) => (
          <div key={index} className="leader-card">
            <img src={convenor.image} alt={convenor.title} />
            <h3>{convenor.title}</h3>
            <p>{convenor.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Leadership;
